var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(!!_vm.to ? 'router-link' : 'div',{tag:"component",staticClass:"new-shipment-sidebar-group tw-flex tw-flex-col",class:{
    'is-link': !!_vm.to,
    'disabled': _vm.$attrs.disabled
  },attrs:{"to":_vm.to,"event":_vm.$attrs.disabled ? '' : 'click'}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }